import { defineConfig } from '@vueform/vueform';
import bootstrap from '@vueform/vueform/dist/bootstrap';
import fr from '@vueform/vueform/locales/fr';

export default defineConfig({
  theme: bootstrap,
  locales: { fr },
  locale: 'fr',
  expression: {
    functions: {
      MIA_API(product: string, environment: string) {
        let suffix = '.eyesoft.fr';
        if (product === 'visionlab') {
          suffix = '.eyesoft.care';
        }
        let correctedEnvironment = '';
        if (environment === 'beta') {
          correctedEnvironment = '.stable';
        } else if (environment === 'recette') {
          correctedEnvironment = '.develop';
        }
        return `https://api.${product}${correctedEnvironment}${suffix}`;
      },
      MIA_BUNDLE_ID(product: string) {
        if (product === 'opticien') {
          return 'fr.eyesoft.app';
        }
        return `fr.eyesoft.${product}.app`;
      },
    },
  },
});
